import { TableFilter } from '@components/table/types';
import { ValueLabelPair } from '@components/table/types/DateMinMax.type';

/**
 * Generates a query parameter for an applied filter.
 * @param key - The filter key.
 * @param value - The filter value.
 * @returns A string representing the query parameter or `null` if the filter should be removed.
 */
export const getQueryParamForAppliedFilter = (key: string, value: any): string | null => {
  if (Array.isArray(value)) {
    const ids = value?.map((v: string | ValueLabelPair) => (typeof v === 'string' ? v : v.value));
    return ids.length > 0 ? ids.join(',') : null;
  } else if (typeof value === 'object') {
    switch (value?.type) {
      case TableFilter.DATE_RANGE: {
        if (value.min || value.max) {
          return `${value?.min ? new Date(value.min)?.toISOString() : null},${value?.max ? new Date(value.max)?.toISOString() : null}`;
        }
        return null;
      }
      case TableFilter.NUMBER_RANGE: {
        if (value.min || value.max) {
          return `${value?.min ? value.min.toString() : null},${value?.max ? value.max?.toString() : null}`;
        }
        return null;
      }
      default:
        return value?.value ? value.value : null;
    }
  } else {
    return value ? value.toString() : null;
  }
};
